var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading"},[_c('div',[_c('van-loading',{attrs:{"color":"#1989fa","size":"48","vertical":""}},[_vm._v("自动登录中，请稍候...")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }